export default {
    title: "Coś poszło nie tak",
    description:
        "Przepraszamy, wystąpił nieoczekiwany błąd. Nasz zespół został powiadomiony i pracuje nad rozwiązaniem problemu.",
    tryAgain: "Spróbuj ponownie",
    goHome: "Strona główna",
    helpText: "Jeśli problem będzie się powtarzał, skontaktuj się z naszym",
    supportTeam: "zespołem wsparcia",
};
